import { Component, OnInit } from '@angular/core';

import { Platform, AlertController } from '@ionic/angular';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { GlobalPage } from '../global/global.page';
import { Storage } from "@ionic/storage";

import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { SQLite, SQLiteObject } from '@awesome-cordova-plugins/sqlite/ngx';

@Component({
  selector: 'app-userdetail',
  templateUrl: './userdetail.page.html',
  styleUrls: ['./userdetail.page.scss'],
})
export class UserdetailPage implements OnInit {
  appVersionNumber: any;
  database: any = [];
  userdetails: any = [];
  constructor(private device: Device, public http: HttpClient, public storage1: Storage,
    private sqlite: SQLite, public global: GlobalPage, private appVersion: AppVersion,
    public platform: Platform, public alertCtrl: AlertController) {
  }

  ngOnInit() {
  }
  async devicepushregistration() {
    let version: any;
    await this.storage1.get("Version").then((val) => {
      version = val;
    });
    //   alert(this.global.employee_ID);
    //   alert(this.global.token);
    // alert( this.global.uuid);
    //   alert(this.global.device_Platform);
    //   alert(this.global.model);
    //   alert(this.global.device_Manufacture);
    //   alert(this.global.device_Serial);
    if (this.platform.is("android")) {
      this.userdetails = {
        driver: this.global.employee_ID,
        uUI_Id: this.global.uuid,
        device_Platform: this.global.device_Platform,
        model: this.global.model,
        device_Manufacture: this.global.device_Manufacture,
        device_Serial: this.global.device_Serial,
        pushUser_Id: this.global.token,
        version: version ? version : ""
      }
    }
    else if (this.platform.is("ios")) {
      this.userdetails = {
        driver: this.global.employee_ID,
        uUI_Id: this.device.uuid,
        device_Platform: this.device.platform,
        model: this.device.version,
        device_Manufacture: this.device.manufacturer,
        device_Serial: this.device.uuid,
        pushUser_Id: this.global.token,
        version: version ? version : ""
      }
    }
    this.userdetails = JSON.stringify(this.userdetails)
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    console.log(this.userdetails, 'userdetail', this.device.uuid != null && !this.userdetails.pushUser_Id)
    console.log(this.userdetails.pushUser_Id != null)
    if (this.device.uuid != null && !this.userdetails.pushUser_Id) {
      let url = "api/Notification/InsertNoticationDet";
      this.http.post(url, this.userdetails, httpOptions).subscribe(
        (data: any) => {
        }
        ,
        err => {
          // console.log(err);
        }
      );
    }
  }
  devicepushRemove() {
    if (this.platform.is("android")) {
      this.userdetails = {
        driver: this.global.employee_ID,
        uUI_Id: "",
        device_Platform: "",
        model: "",
        device_Manufacture: "",
        device_Serial: "",
        pushUser_Id: "",
        version: ""
      }
    }
    else if (this.platform.is("ios")) {
      this.userdetails = {
        driver: this.global.employee_ID,
        uUI_Id: "",
        device_Platform: "",
        model: "",
        device_Manufacture: "",
        device_Serial: "",
        pushUser_Id: "",
        version: ""
      }
    }
    this.userdetails = JSON.stringify(this.userdetails)
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    if (this.device.uuid != null) {
      let url = "api/Notification/InsertNoticationDet";
      this.http.post(url, this.userdetails, httpOptions).subscribe(
        (data: any) => {
        }
        ,
        err => {
          // console.log(err);
        }
      );
    }
  }
  async deviceUpdateCheck() {
    this.platform.ready().then(() => {
      this.appVersion.getVersionNumber().then(data => {
        this.appVersionNumber = data;
        this.storage1.get("Version").then((val) => {
          if (val != this.appVersionNumber || !val) {
            this.storage1.set("Version", this.appVersionNumber)
            //  this.reloadtrans();
          }

        })
      }).then(data => {
        if (this.device.uuid != null) {
          let url = "api/TransMySchedule/getlatestversion?";
          let myParams = new URLSearchParams();
          myParams.append("OldVersion", this.appVersionNumber)
          myParams.append("OSPlatform", this.device.platform)
          this.http.get(url + myParams).subscribe(
            async (data: any) => {
              this.global.mustUpdate = data.isMust;
              // if(data.isDevicechanges)
              // {
              //   const alert = this.alertCtrl.create({
              //     title: "Device Login",
              //     message: "You have already logged in with another device,so it will be automatically logged out, once you login in your new device",
              //     buttons: [
              //       {
              //         text: "Ok",
              //         handler: data => {
              //         }
              //       }
              //     ]
              //   });
              //   alert.present();   
              // }
              if (data.isMust && this.appVersionNumber != data.versionNumber) {

                const alert = this.alertCtrl.create({
                  header: "App Update",
                  message: "Your app needs update to proceed further",
                  buttons: [
                    {
                      text: "Update",
                      handler: data => {
                        this.mustUpdate();
                      }
                    }
                  ],
                  //  enableBackdropDismiss: false
                });
                (await alert).present();
              }
              else if (data.isOptional && this.appVersionNumber != data.versionNumber) {
                const confirm = this.alertCtrl.create({
                  header: "App Update",
                  message: "New Update is Available",
                  buttons: [
                    {
                      text: 'Update',
                      handler: () => {
                        this.mustUpdate();
                      }
                    },
                    {
                      text: 'Later',
                      role: "cancel",
                      handler: () => {
                      }
                    }
                  ],
                  //  enableBackdropDismiss: false
                });
                (await confirm).present();
              }
            },
            err => {
              // console.log("err", err)
            }
          );
        }
      })
    })
  }
  mustUpdate() {
    if (this.platform.is("android")) {
      window.location.href = "https://play.google.com/store/apps/details?id=com.sbna.alltranssoftware";
    }
    else if (this.platform.is("ios")) {
      window.location.href = "https://itunes.apple.com/us/app/alltranssoftware-mobile-driver/id1456598776?ls=1&mt=8";
    }
  }
  reloadtrans() {
    ////----TO DELETE TABLE ON PAGE LOAD AND THEN CREATE IT---/////
    this.sqlite.create({
      name: 'data.db',
      location: 'default'
    })
      .then((db: SQLiteObject) => {

        this.database = db;
        this.sqlite.deleteDatabase({ name: 'data.db', location: 'default' }
        ).then(() =>
        // this.getdataoffline()

        {
          this.createsql();
          this.createsqlroute();
          this.createsqlroutefinal();
        }
        )
          .catch(e => console.log(e));
      })
      .catch(e => console.log(e));
    ////----TO DELETE TABLE ON PAGE LOAD AND THEN CREATE IT---/////
  }
  //////------CREATE TABLE TRANS FOR OFFLINE---/////
  createsql() {
    this.sqlite.create({
      name: 'data.db',
      location: 'default'
    })
      .then((db: SQLiteObject) => {

        this.database = db;
        db.executeSql('CREATE TABLE IF NOT EXISTS trans(tblID INTEGER UNIQUE,isUpdate VARCHAR(32),destinationNew VARCHAR(32),pickNew VARCHAR(32),ageYears INTEGER,apptTime VARCHAR(32),fromPhone VARCHAR(32),callPhone VARCHAR(32),departTime VARCHAR(32),destination VARCHAR(32),driver INTEGER,driverPIN INTEGER,endGPSLat VARCHAR(32),endGPSLon VARCHAR(32),endTime VARCHAR(32),hasInspectionReports VARCHAR(32),inRoute VARCHAR(32), leg VARCHAR(32),legStatus VARCHAR(32),memberName VARCHAR(32),noSigReq VARCHAR(32),numberOfCarSeats VARCHAR(32),odometerEnd VARCHAR(32),odometerStart VARCHAR(32),odometerYN VARCHAR(32),offline INTEGER,onlyLeg INTEGER,process VARCHAR(32),pU_Time VARCHAR(32),pickup VARCHAR(32),pickupTime VARCHAR(32),printSigName VARCHAR(32),puTime VARCHAR(32),routedYN VARCHAR(32),scheduledDropTime VARCHAR(32),signatureImage VARCHAR(32),signatureFacilityImagePath VARCHAR(32),signatureImagePath VARCHAR(32),signatureType VARCHAR(32),spath VARCHAR(32),startGPSLat VARCHAR(32),startGPSLon VARCHAR(32),startTime VARCHAR(32),startTimeLeg VARCHAR(32),sts VARCHAR(32),totalMiles INTEGER,transID INTEGER,tripAccepted VARCHAR(32),tripAcceptedDate VARCHAR(32),tripComplete VARCHAR(32),tripNote VARCHAR(32),notes VARCHAR(32),wcStr VARCHAR(32),driverPINVerified INTEGER,driverPINVerifiedDate VARCHAR(32))', [])
          .then(() =>
            console.log("trans")
          )
          .catch(e => console.log(e));
      })
      .catch(e => console.log(e));
  }
  //////------CREATE TABLE ROUTE FOR OFFLINE---/////
  createsqlroute() {
    this.sqlite.create({
      name: 'data.db',
      location: 'default'
    })
      .then((db: SQLiteObject) => {
        db.executeSql('CREATE TABLE IF NOT EXISTS route(id INTEGER,tblID INTEGER UNIQUE,isUpdate VARCHAR(32),leg VARCHAR(32),pickNew VARCHAR(32),apptTime VARCHAR(32),departTime VARCHAR(32),destinationNoAddress VARCHAR(32),driver INTEGER,dropTime VARCHAR(32),endGPSLat VARCHAR(32),endGPSLon VARCHAR(32),endTime VARCHAR(32),fromPhone VARCHAR(32),pU_Phone VARCHAR(32),legNotes VARCHAR(32),inRoute VARCHAR(32),legStatus VARCHAR(32),memberName VARCHAR(32),notes VARCHAR(32),offline INTEGER,onlyLeg INTEGER,process VARCHAR(32),pU_time VARCHAR(32),pickup VARCHAR(32),pickupTime VARCHAR(32),rteName VARCHAR(32),startGPSLat VARCHAR(32),startGPSLon VARCHAR(32),transID INTEGER,tripComplete VARCHAR(32),totalPassengers INTEGER,tripNotes VARCHAR(32))', [])
          .then(() => { }
            // console.log("route")
          )
          .catch(e => console.log(e));
      })
      .catch(e => console.log(e));
  }
  //////------CREATE TABLE ROUTE FINAL FOR OFFLINE---/////
  createsqlroutefinal() {
    this.sqlite.create({
      name: 'data.db',
      location: 'default'
    })
      .then((db: SQLiteObject) => {
        db.executeSql('CREATE TABLE IF NOT EXISTS routefinal(id INTEGER,tblID INTEGER UNIQUE,pU_time VARCHAR(32),startGPSLat VARCHAR(32),startGPSLon VARCHAR(32),transID INTEGER)', [])
          .then(() => { }
            // console.log("route final")
          )
          .catch(e => console.log(e));
      })
      .catch(e => console.log(e));
  }
  // ///////---TO LOAD OFFLINE DASHBOARD DATA---/////////

}
